const summary= 'Summary of Comments';
const title= ''

export default {
    summary: summary,
    title: title
}